export const childMissionNotifications = {
  1: {
    name: 'Cyberbullying',
    start: {
      type: 'MISSION_STARTED_MISSION_1',
      message:
        '{child first name} just began learning how cyberbullying works and how it affects people emotionally! This mission helps them recognize harmful behaviors early and understand what safe responses look like! 💛'
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_1',
      message:
        '{child first name} learned how to identify harassment, intimidation, and hurtful online behavior and how to respond using Stop Screenshot Block Report! These skills empower them to stay confident, safe, and supportive toward others online! ⭐'
    }
  },
  2: {
    name: 'Digital Footprints and IP Addresses',
    start: {
      type: 'MISSION_STARTED_MISSION_2',
      message:
        "{child first name} is beginning to explore how every online action leaves a digital footprint! They're learning why these traces matter for privacy, safety, and their future digital reputation! 👣"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_2',
      message:
        '{child first name} learned how digital footprints and IP addresses reveal information about online activity! These skills help them make thoughtful choices that protect their privacy now and in the long run! 🔐'
    }
  },
  3: {
    name: 'Password Protection and Device Safety',
    start: {
      type: 'MISSION_STARTED_MISSION_3',
      message:
        "{child first name} just started learning how account takeovers happen and why strong passwords matter so much! They're beginning to understand how safe device habits protect their personal world online! 🔑"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_3',
      message:
        '{child first name} learned how to create strong passwords, use multi-factor authentication, and stay safe on shared devices! These habits reduce the risk of account breaches and keep their personal information secure! 🛡️'
    }
  },
  4: {
    name: 'Privacy and Safe-to-Share Information',
    start: {
      type: 'MISSION_STARTED_MISSION_4',
      message:
        "{child first name} is learning the difference between private and personal information and why oversharing can create risks! They're starting to explore how geotags and photos reveal more than they seem! 📍"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_4',
      message:
        '{child first name} learned how to make safer sharing decisions by understanding privacy, geotags, and when consent is required! These skills help them protect their identity, location, and relationships online! 📸'
    }
  },
  5: {
    name: 'Identity Theft and Phishing',
    start: {
      type: 'MISSION_STARTED_MISSION_5',
      message:
        "{child first name} just started learning how scammers use fake messages, links, and impersonation to trick people! They're beginning to understand why children's identities are valuable targets! ⚠️"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_5',
      message:
        '{child first name} learned how to spot phishing red flags, verify suspicious messages, and protect personal information from identity theft! These skills help them stay alert and avoid dangerous online traps! 🎣'
    }
  },
  6: {
    name: 'Online Scams',
    start: {
      type: 'MISSION_STARTED_MISSION_6',
      message:
        "{child first name} is beginning to explore how fake prizes, scareware, and suspicious offers try to manipulate people! They're discovering how to pause and look for signs something isn't real! 🎁"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_6',
      message:
        '{child first name} learned how to identify common scam tactics like urgency, emotional pressure, and fake links! These skills help them make safer decisions and avoid being misled online! 🚫'
    }
  },
  7: {
    name: 'Malware',
    start: {
      type: 'MISSION_STARTED_MISSION_7',
      message:
        "{child first name} just started learning what malware is and how harmful software spreads! They're beginning to see how malware affects devices and personal data! 💻"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_7',
      message:
        '{child first name} learned how viruses, worms, Trojans, ransomware, and spyware work and how safe habits prevent attacks! These skills help them protect their devices and keep their data safe! 🦠'
    }
  },
  8: {
    name: 'Catfishing and Fake Profiles',
    start: {
      type: 'MISSION_STARTED_MISSION_8',
      message:
        "{child first name} is beginning to understand how fake profiles are created and why people pretend to be someone they're not! They're learning the early red flags that keep them safe when talking to others online! 🎭"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_8',
      message:
        '{child first name} learned how to spot fake profiles, identify manipulative behaviors, and choose safe responses when something feels off! These skills protect their emotional well-being and help them build safer digital relationships! 💬'
    }
  },
  9: {
    name: 'Grooming and Predators',
    start: {
      type: 'MISSION_STARTED_MISSION_9',
      message:
        "{child first name} just started learning how grooming works and why tactics like secrecy, flattery, and platform hopping are dangerous! They're beginning to understand how their instincts can guide them when something feels wrong! 🚨"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_9',
      message:
        '{child first name} learned how to recognize grooming stages, set digital boundaries, and follow Stop Save Tell! These skills protect them from manipulation and help them respond safely if pressured online! 🛑'
    }
  },
  10: {
    name: 'Social Engineering',
    start: {
      type: 'MISSION_STARTED_MISSION_10',
      message:
        "{child first name} is learning how hackers use urgency, impersonation, and emotional pressure to trick people! They're beginning to understand how to pause and think critically before responding! 🧠"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_10',
      message:
        '{child first name} learned how to spot red flags in phone calls, emails, and messages and how safe responses prevent major security breaches! These skills strengthen their ability to protect themselves and others online! 🔒'
    }
  },
  11: {
    name: 'Extortion and Sextortion',
    start: {
      type: 'MISSION_STARTED_MISSION_11',
      message:
        "{child first name} just started learning how online threats and pressure tactics work and why predators use fear to control people! They're beginning to understand what safe, calm responses look like! ⚡"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_11',
      message:
        "{child first name} learned the five-step safety plan: don't pay, don't send more, save evidence, block or report, tell a trusted adult! These skills help them respond safely and confidently if they ever face digital threats! 🆘"
    }
  },
  12: {
    name: 'AI Literacy and Deepfakes',
    start: {
      type: 'MISSION_STARTED_MISSION_12',
      message:
        "{child first name} is learning how AI creates content and why deepfakes can look real but be misleading! They're beginning to explore clever clues that help them tell what's real and what's not! 🤖"
    },
    completion: {
      type: 'MISSION_COMPLETED_MISSION_12',
      message:
        '{child first name} learned how to spot visual and audio red flags in deepfakes and verify suspicious content before trusting it! These skills help them stay safe in a world where AI can distort reality! 🎥'
    }
  }
}

/**
 * Get notification data for a mission
 * @param {number|string} missionId - The mission ID (1-12)
 * @param {string} notificationType - 'start' or 'completion'
 * @param {string} childFirstName - The child's first name
 * @returns {Object|null} Notification data with type and message, or null if not found
 */
export const getChildMissionNotification = (
  missionId,
  notificationType,
  childFirstName = 'Your child'
) => {
  const mission = childMissionNotifications[missionId]
  if (!mission) return null

  const notification = mission[notificationType]
  if (!notification) return null

  return {
    type: notification.type,
    message: notification.message.replace('{child first name}', childFirstName)
  }
}
